<template>
  <v-card
    :color="matches || hasCity ? 'halightblue2' : 'hafgrey'"
    flat
    :to="post.url_path"
  >
    <v-img :src="thumbnail" width="100%" contain />
    <h4 class="pa-1">{{ post.title }}</h4>
    <div class="pa-1">
      <p class="blogPreviewIntro">{{ post.formatted_first_date }}</p>
      <p class="blogPreviewIntro">{{ intro }}</p>
    </div>
    <!-- <v-chip v-if="hasCity" class="ma-2" color="primary">
      {{ city }}
    </v-chip> -->
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BlogPostPreview',
  props: {
    post: {
      type: Object,
      default: () => {},
    },
    introLimit: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    ...mapState('route', ['query']),
    ...mapState('location', ['availableCities']),
    intro() {
      const INTRO_SIZE = this.introLimit
      const intro = this.post.preview
      return intro.length > INTRO_SIZE
        ? `${intro.slice(0, INTRO_SIZE)}...`
        : intro
    },
    thumbnail() {
      return this.post.main_image
        ? `${this.$config.staticUrl}${this.post.main_image.thumbnail}`
        : require('@/assets/images/happyly_logo_placeholder.png')
    },
    city() {
      if (typeof this.query.city === 'undefined') return null

      const city = this.availableCities.find(
        ({ id }) =>
          id === Number(this.query.city) || id === this.post.match_city
      )

      return city.name
    },
    hasCity() {
      return (
        typeof this.query.city !== 'undefined' &&
        (this.post.cities.includes(Number(this.query.city)) ||
          this.post.cities.includes(this.post.match_city))
      )
    },
    matches() {
      return this.post.score !== null && this.post.score > 3
    },
  },
}
</script>

<style>
.blogPreviewIntro {
  font-size: 12px;
  line-height: 1.5;
}
</style>
